import React, { useEffect, useRef, useCallback, useState} from 'react';
import LeafDetails from './LeafDetails.js';
import {ChromePicker} from 'react-color';
import TidalArt from '../tidal/TidalArt.js';
import Structure from '../tidal/Structure.js';
import SequencerArt from './SequencerArt.js';
import TidalVisualizer from '../TidalVisualizer.js';
import {connect} from 'react-redux';

const ScriptTidals = ({
    tidals, isScript, WIDTH, HEIGHT,
    color = '#A19A9A',
    backgroundColor = '#100B0B',
    fillColor = '#757474',
    dotColor = '#B5B5B5'
}) => { 
    let displayRef = useRef();
    let [showColors, setShowColors] = useState(false);

    let [display, setDisplay] = useState({x: 0, y:0});
    let [leafDetails, setLeafDetails] = useState(undefined);
    let inUse = tidals.filter(x => x.inUse || x.lastUsed < 1);
    let main = inUse[0];

    if (inUse.length === 0) {
        return '';
    }

    return (
        <div  className="script-tidals">
          {leafDetails &&
           <LeafDetails
             setLeafDetails={setLeafDetails}
             sequencerEngine={tidals[0].track.sequencerEngine}
             leaf={leafDetails}/>
          }
          <div ref={displayRef} className="display"><span></span></div>
          {/*<SequencerArt displayRef={displayRef} backgroundColor={backgroundColor} color={color} tidals={inUse} total={inUse.length}/>*/}
         <Structure
            leafDetails={leafDetails}
            setLeafDetails={setLeafDetails}
           isScript={isScript}
            sequencerEngine={tidals[0].track.sequencerEngine}
            backgroundColor={backgroundColor}
            color={color}
           fillColor={fillColor}
            WIDTH={WIDTH}
            HEIGHT={HEIGHT}
           dotColor={dotColor}
            tidals={tidals}
            />
          <TidalArt
            leafDetails={leafDetails}
            WIDTH={WIDTH}
            HEIGHT={HEIGHT}
            setLeafDetails={setLeafDetails}
            sequencerEngine={tidals[0].track.sequencerEngine}
            backgroundColor={backgroundColor}
            dotColor={dotColor}
            color={color}
            tidals={inUse}
           total={inUse.length}/>
        </div>
    );
};

const mapStateToProps = (state, props) => {
    let x = {};
    props.tidals.forEach(
        tidal => x[tidal.id] = tidal.inUse);
    return x;
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScriptTidals);
